module.exports = __webpack_public_path__ + "static/media/bac-street-selected.1b93549b.svg";